import React from 'react';

const num = (v) => (v == null ? '—' : Number(v).toLocaleString('en-US'));

export function PerformanceSummaryCards({ summary, loading }) {
  if (loading) return <p className="loading-msg">Loading summary…</p>;
  const s = summary || {};
  const cards = [
    { label: 'Deposits', value: num(s.deposits) },
    { label: 'Withdrawals', value: num(s.withdrawals) },
    { label: 'Net deposit', value: num(s.net_deposit) },
    { label: 'FTDs (count)', value: num(s.ftd_count) },
    { label: 'FTDs (sum)', value: num(s.ftd_sum) },
    { label: 'P&L', value: num(s.pnl) },
    { label: 'Volume', value: num(s.volume) },
    { label: 'Total reward', value: num(s.reward_total) },
  ];
  return (
    <div className="summary-cards">
      {cards.map((c) => (
        <div className="summary-card" key={c.label}>
          <div className="value">{c.value}</div>
          <div className="label">{c.label}</div>
        </div>
      ))}
    </div>
  );
}
